import { TileItem } from "./item.tile.component";
import { SEEventDocument, SEOrganizationDocument } from "./se.search.service";
import { Item } from "../../../pojo/Item";
import { SeEvent } from "../event/se.event.details.view.component";
import { attendanceState } from "../attendance/attendance.service";

/**
 * Utility functions for converting API documents and domain models to TileItem format
 */

/**
 * Convert SEEventDocument to TileItem for display in tiles
 */
export function convertEventDocumentToTileItem(doc: SEEventDocument): TileItem {
    return {
        itemId: doc.itemId,
        itemName: doc.itemName,
        itemTypeId: Item.Ids.Event,
        txt: doc.title || doc.txt || "",
        date: doc.startDate || doc.date || "",
        locations: doc.spaces?.map((space) => space.itemName).filter((name) => !!name),
        description: doc.description || (doc.txt !== doc.itemName ? doc.txt : ""),
        occurrences: doc.occurrences,
        hostOrgId: doc.hostOrgId,
        hostOrgName: doc.hostOrgName,
        hostOrgLogoUrl: doc.hostOrgLogoUrl,
        imageUrl: doc.imageUrl,
        additionalOrganizations: doc.additionalOrganizations,
        reservationId: doc.reservationId,
        logosResolvedFromSearch: true,
    };
}

/**
 * Convert SEOrganizationDocument to TileItem for display in tiles
 */
export function convertOrganizationDocumentToTileItem(doc: SEOrganizationDocument): TileItem {
    return {
        itemId: doc.itemId,
        itemName: doc.itemName,
        itemTypeId: Item.Ids.Organization,
        txt: doc.txt,
        title: doc.title,
        mission: doc.mission,
        type: doc.type,
        members: doc.members?.map((m) => ({
            itemId: m.contactId,
            itemName: m.contactName,
            itemEmail: m.email,
            role: m.role && { itemId: m.role.roleId, itemName: m.role.roleName },
        })),
        primaryContact: doc.primaryContact && {
            itemId: doc.primaryContact.contactId,
            itemName: doc.primaryContact.contactName,
            itemEmail: doc.primaryContact.email,
        },
        rating: doc.rating && {
            itemId: doc.rating.ratingId,
            itemName: doc.rating.ratingName,
            organizationStanding: doc.rating.organizationStanding,
        },
        categories: doc.categories?.map((c) => ({ itemId: c.categoryId, itemName: c.categoryName })),
        eventCount: doc.eventCount,
        lastModified: doc.lastModified,
        userRoles: doc.userRoles?.map((r) => ({ itemId: r.roleId, itemName: r.roleName })),
        favorite: doc.favorite,
        logoUrl: doc.logoUrl ?? doc.logo,
        logosResolvedFromSearch: true,
    };
}

/**
 * Convert SeEvent (domain model) to TileItem for display in tiles
 */
export function convertSeEventToTileItem(event: SeEvent): TileItem {
    return {
        itemId: event.itemId,
        itemName: event.itemName,
        itemTypeId: Item.Ids.Event,
        date: event.date,
        locations: event.locations,
        description: event.description,
        occurrences: event.occurrences?.map((occurrence) => ({
            reservationId: occurrence.reservationId,
            attendanceState: occurrence.attendanceState ?? attendanceState.NOT_INTERESTED,
        })),
        hostOrgId: event.hostOrg?.itemId,
        hostOrgName: event.hostOrg?.itemName,
        additionalOrganizations: event.additionalOrganizations,
        reservationId: event.reservationId,
    };
}
